/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnecttitle2Inputs */

const en_crosspostingconnecttitle2 = /** @type {(inputs: Crosspostingconnecttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Accounts`)
};

const de_crosspostingconnecttitle2 = /** @type {(inputs: Crosspostingconnecttitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten verbinden`)
};

/**
* | output |
* | --- |
* | "Connect Accounts" |
*
* @param {Crosspostingconnecttitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnecttitle2 = /** @type {((inputs?: Crosspostingconnecttitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnecttitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnecttitle2(inputs)
	return de_crosspostingconnecttitle2(inputs)
});
export { crosspostingconnecttitle2 as "crosspostingConnectTitle" }